import { render, staticRenderFns } from "./ExpertMajor.vue?vue&type=template&id=ca4a6fee&scoped=true&"
import script from "./ExpertMajor.vue?vue&type=script&lang=js&"
export * from "./ExpertMajor.vue?vue&type=script&lang=js&"
import style0 from "./ExpertMajor.vue?vue&type=style&index=0&id=ca4a6fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a6fee",
  null
  
)

export default component.exports